/* import __COLOCATED_TEMPLATE__ from './right.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();